import Menu, { MenuList, MenuItem } from 'components/Menu';
import { IoCopyOutline, IoTrashOutline } from 'react-icons/io5';
import { RxDotsHorizontal } from 'react-icons/rx';
import { styled } from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const MenuIcon = styled.div`
  border-radius: 100%;
  width: 34px;
  height: 34px;
  background-color: ${(props) => props.theme.global.mainColor};
  color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 0px 4px;
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

interface ProjectCardMenuProps {
  onMenuButtonClick: (event: React.MouseEvent) => void;
  onCopyButtonClick: () => void;
  onDeleteButtonClick: () => void;
}

const ProjectCardMenu = ({ onCopyButtonClick, onDeleteButtonClick, onMenuButtonClick }: ProjectCardMenuProps) => {
  return (
    <Container onClick={onMenuButtonClick}>
      <Menu
        trigger={
          <MenuIcon className="menu-icon">
            <RxDotsHorizontal />
          </MenuIcon>
        }
        vertical="top"
        horizontal="right"
      >
        <MenuList>
          <MenuItem>
            <button onClick={onCopyButtonClick}>
              <IoCopyOutline />
              <span>복제하기</span>
            </button>
          </MenuItem>
          <MenuItem>
            <button onClick={onDeleteButtonClick}>
              <IoTrashOutline />
              <span>삭제하기</span>
            </button>
          </MenuItem>
        </MenuList>
      </Menu>
    </Container>
  );
};

export default ProjectCardMenu;
